import React from 'react'

export default function Intro({ type, handleStartTest }) {
 return (
   <div className="min-h-screen bg-gradient-to-b from-white to-red-200 flex items-center justify-center">
     <div className="max-w-2xl w-full mx-6"> 
       <h1 className="text-5xl font-bold text-center mb-16">
         <span className="text-[#F97B5C]">Hello,</span>{' '}
         <span className="text-[#333]">I'm HRgpt!</span>
       </h1>

       <div className="bg-white rounded-2xl shadow-sm p-8">
         <h2 className="text-2xl font-semibold text-gray-800 mb-2">
           {type === 'preScreening' ? ' Pre-screening Test' : 'Psychoanalytical Assessment'}
         </h2>
         <p className="text-gray-600 mb-8">
           Click on the start button to start your {type === 'preScreening' ? 'pre-screening' : 'psychoanalytical'} test created by HRgpt
           from Organization. All the best!
         </p>

         <button
           onClick={handleStartTest}
           className="w-full bg-gradient-to-r from-[#FAD961] to-[#F97B5C] text-white py-4 rounded-full font-medium hover:opacity-90 flex items-center justify-center gap-2"
         >
           <span className="text-xl">✨</span>
           <span className="text-xl">Start Test</span>
         </button>
       </div>
     </div>
   </div>
 )
}